import React from "react";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="navbar">
      <h1
        className="logo"
        style={{ cursor: "pointer" }}
        onClick={() => handleNavigation("/")}
      >
        Stockasti<span style={{ color: "var(--green)" }}>x</span>
      </h1>
      <div className="links">
        <button className="ic2" onClick={() => navigate("/comparestocks")}>
          Compare &#8599;
        </button>
        <div><span onClick={() => handleNavigation("/ticker")}>Discover</span></div>
        <div><span onClick={() => handleNavigation("/economicdata")}>Economic Analysis</span></div>
        <div><span onClick={() => handleNavigation("/login")}>Login</span></div>
      </div>
    </div>
  );
}

export default Navbar;
